import { isValid, parseISO } from "date-fns/esm";

import { getNowTimeMs } from "utils/time";

/**
 * Determines if an integration should display the "New" badge based on its newUntil date.
 *
 * @param newUntil - ISO 8601 date string (YYYY-MM-DD) indicating when the "New" label expires
 * @returns true if the integration should show the "New" badge, false otherwise
 */
export const isIntegrationNew = (newUntil: string | undefined): boolean => {
  if (!newUntil) return false;

  const parsedDate = parseISO(newUntil);
  if (!isValid(parsedDate)) return false;

  const [year, month, day] = newUntil.split("-").map(Number);
  const expirationTimestamp = Date.UTC(year, month - 1, day, 23, 59, 59, 999);
  const now = getNowTimeMs();
  return now <= expirationTimestamp;
};
